import HeroSection from '../../components/HeroSection/HeroSection';
import Stats from '../../components/Stats/Stats';
import Team from '../../components/Team/Team';
import IITCards from '../../components/IITCards/IITCards';
import WhySection from '../../components/WhySection/WhySection';
import Testimonials from '../../components/Testimonials/Testimonials';
import Footer from '../../components/Footer/Footer';


    

function LandingPage() {
    return (
        <>
            <HeroSection />
            <elevenlabs-convai agent-id="agent_6001k906ndgzee69c8hjc31kv5fg"></elevenlabs-convai>
            <Stats />
            <Team />
            <IITCards />
            <WhySection />
            <Testimonials />
        </>
    );
}

export default LandingPage;